import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { Cart } from './../models/cart';

@Injectable({
    providedIn: 'root'
})

export class CartService {
    controller = 'Cart';

    constructor(private base: BaseService) { }


    getAll(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAll/' + id)
    }

    addToCart(obj: Cart) {
        return this.base.save(this.controller + '/RegisterCart', obj);
    }

    delete(id: number) {
        return this.base.deleteCart(this.controller + '/DeleteItem', id);
    }
}